"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinMappingDenormalizedSchema = exports.PinDenormalizedSchema = void 0;
exports.convertSignalsToPinMapping = convertSignalsToPinMapping;
const zod_1 = require("zod");
exports.PinDenormalizedSchema = zod_1.z.object({
    pinId: zod_1.z.string().describe('The pin number or identifier'),
    signalName: zod_1.z.string().describe('The name of the signal attached to the pin'),
});
exports.PinMappingDenormalizedSchema = zod_1.z.object({
    pins: zod_1.z.array(exports.PinDenormalizedSchema),
});
function convertSignalsToPinMapping(signals) {
    const pins = signals.flatMap((signal) => {
        const pinRefs = signal.pinRefs?.filter((ref) => ref !== null) ?? [];
        return pinRefs.map((pinRef) => ({
            pinId: pinRef,
            signalName: signal.name,
        }));
    });
    return { pins };
}
//# sourceMappingURL=pin-mapping-denormalized.js.map